
import ReturnDisplay from "@/components/generic/ReturnDisplay.vue";
import { trans } from "@/i18n";
import { EventBus } from "@/plugins/eventBus";
import { FraudForceResult, IFraudForceResult } from "@/plugins/fraudForce";
import { GetValue } from "@/plugins/utilities";
import { LogIt } from "@/plugins/webApi";
import Vue from 'vue';
import { Iovation } from '@/plugins/iovation';

export default Vue.extend({
    data() {
        return {
            showResults: false,
            fraudResult: {} as IFraudForceResult,
            ffDisplay: {} as any,
        };
    },
    components: {ReturnDisplay},
    mounted() {
        //Delay call so BB collection has time to complete
        setTimeout(() => {this.sendFraudForce()}, 1000);
    },
    methods: {

        sendFraudForce(): void {
            (this as any).fraudResult = {} as IFraudForceResult;
            EventBus.$emit('message', {text: 'Sending Device Risk Call'});
            const bboxEl = document.querySelector('#ioBB');
            const io = new Iovation({
                name: (this as any).name,
                blackbox: GetValue(bboxEl || new Element(), 'value'),
                data: {
                    user: "BOB",
                    ti: (this as any).ti,
                    type: 'apply',
                },
            });

            io.Send()
            .then((result) => {
                EventBus.$emit('message', {text: 'Device Risk is back!'});
                if (!result.data.code) {
                    this.showResults = true;
                    (this as any).fraudResult = result.data;
                    (this as any).ffDisplay = new FraudForceResult((this as any).fraudResult as IFraudForceResult).formatDeviceCollection('rgba(128,128,128,0.2)');
                    EventBus.$emit('raw', {text: JSON.stringify(result.data)});
                    LogIt(`(Components/FraudForce.vue)->sendFraudForce() iovation FraudForce has been invoked [IDV] [FF] ${result.data['trackingNumber']} ${result.data['id']}`, false);
                } else {
                    EventBus.$emit('message', {context: 'error', text: `${trans('error')} ${result.data.message}`});
                    LogIt(`(Components/FraudForce.vue)->sendFraudForce() [IDV] [FF] error ${result.data.message}`, true);
                }
            })
            .catch((reason) => {
                console.log("error", reason)
                EventBus.$emit('message', {text: `${trans('error')} ${reason}`, context: 'error'});
                LogIt(`(Components/FraudForce.vue)->sendFraudForce() ${reason}`, true);
            });
        },

    }
});
